import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "flex items-center justify-between mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pvz_upload_photo = _resolveComponent("pvz-upload-photo")!
  const _component_pvz_add_user = _resolveComponent("pvz-add-user")!
  const _component_pvz_form = _resolveComponent("pvz-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_pvz_filters = _resolveComponent("pvz-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_pvz_table_actions_button = _resolveComponent("pvz-table-actions-button")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.upload_state.opened)
      ? (_openBlock(), _createBlock(_component_pvz_upload_photo, {
          key: 0,
          "pvz-id": _ctx.upload_state.pvz_id,
          "pvz-name": _ctx.upload_state.pvz_name,
          onCancel: _ctx.cancelUpload
        }, null, 8, ["pvz-id", "pvz-name", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.user_state.opened)
      ? (_openBlock(), _createBlock(_component_pvz_add_user, {
          key: 1,
          "pvz-id": _ctx.user_state.pvz_id,
          onCancel: _ctx.onCancelAddUser
        }, null, 8, ["pvz-id", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.form_state.is_visible)
      ? (_openBlock(), _createBlock(_component_pvz_form, {
          key: 2,
          "initial-value": _ctx.form_state.initial_value,
          "is-update": _ctx.form_state.is_update,
          "is-create": _ctx.form_state.is_create,
          "is-add-user": _ctx.form_state.is_add_user,
          onRefresh: _ctx.closePVZForm
        }, null, 8, ["initial-value", "is-update", "is-create", "is-add-user", "onRefresh"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_page_title, { title: "ПВЗ" }),
            _createVNode(_component_the_button, {
              class: "primary small",
              onClick: _ctx.onAddPVZ
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить ПВЗ ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_pvz_filters, {
            class: "mt-6",
            loading: _ctx.state.pvz.is_loading,
            onSearch: _ctx.onSearch,
            onReset: _ctx.onReset
          }, null, 8, ["loading", "onSearch", "onReset"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_page_title, { title: "Список ПВЗ" })
            ]),
            (_ctx.state.pvz.is_failed && !_ctx.state.pvz.failure.error_state.is_cancel)
              ? (_openBlock(), _createBlock(_component_failed_fetch, {
                  key: 0,
                  loading: _ctx.state.pvz.is_loading,
                  text: "При получении списка ПВЗ произошла ошибка",
                  "error-message": _ctx.state.pvz.failure.error_state.message,
                  "error-url": _ctx.state.pvz.failure.error_state.url,
                  "error-status": _ctx.state.pvz.failure.error_state.status,
                  onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadPVZ(_ctx.state.pvz.pagination.current_page)))
                }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
              : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                  key: 1,
                  loading: _ctx.state.pvz.is_loading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_table, {
                      loading: _ctx.state.pvz.is_loading,
                      columns: _ctx.PVZColumns,
                      rows: _ctx.state.pvz.list,
                      pagination: "",
                      "pagination-current-page": _ctx.state.pvz.pagination.current_page,
                      "pagination-limit": _ctx.state.pvz.pagination.limit,
                      "pagination-total-items": _ctx.state.pvz.pagination.total_items,
                      "pagination-total-pages": _ctx.state.pvz.pagination.total_pages,
                      onChangePage: _ctx.loadPVZ
                    }, {
                      td: _withCtx(({ column, row }) => [
                        (column.key === 'city' && row.city)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(row.city.name), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                            ], 64))
                      ]),
                      actions: _withCtx(({ row }) => [
                        _createVNode(_component_pvz_table_actions_button, {
                          item: row,
                          onUpdate: _ctx.onUpdatePVZ,
                          onAddUser: _ctx.onAddUser,
                          onUpload: _ctx.startUpload
                        }, null, 8, ["item", "onUpdate", "onAddUser", "onUpload"])
                      ]),
                      _: 1
                    }, 8, ["loading", "columns", "rows", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"])
                  ]),
                  _: 1
                }, 8, ["loading"]))
          ])
        ], 64))
  ]))
}